/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Constants for Labels Import
 *
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.3.0
 */

import { EHttpMethod } from '../../modules/app/appConstants';

export const LABELS_IMPORT_CHECK_VALIDATION_DELAY_MS = 2000;
export const LABELS_IMPORT_TASK_PROCESSING_DELAY_MS = 2000;
export const LABELS_IMPORT_LINEAR_LOADERS_COUNT = 6;

export enum ELabelsImportSteps {
    File = 'UploadLabelsStep',
    Final = 'ValidationLabelsStep',
}

export enum ELabelsImportValidationCodes {
    FILE_FORMAT_INCORRECT = 'file.format.incorrect',
    FILE_SIZE_EXCEEDED = 'system.error.max.file.size.exceeded',
    FILE_NOT_FOUND = 'file.not.found',
}

export enum ELabelsImportField {
    LABEL = 'label',
    MSISDN = 'msisdn',
    STATUS = 'status',
}

export enum ELabelsImportRowStatus {
    FULLY_IMPORTED = 'FULLY_IMPORTED',
    NOT_IMPORTED = 'NOT_IMPORTED',
    PARTIALLY_IMPORTED = 'PARTIALLY_IMPORTED'
}

export enum ELabelsImportLabelsValidationRequest {
    CHECK = 'CHECK',
    INTERRUPT = 'INTERRUPT',
    START = 'START',
}

export enum ELabelsImportLabelsValidationStatus {
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
    INTERRUPTED = 'INTERRUPTED',
    PREPARING = 'PREPARING',
    READY = 'READY',
    RUNNING = 'RUNNING',
    UNDEFINED = 'UNDEFINED',
}

export const MapLabelsValidationRequestToHttpMethod: {[key in ELabelsImportLabelsValidationRequest]: EHttpMethod} = {
    [ELabelsImportLabelsValidationRequest.CHECK]: EHttpMethod.GET,
    [ELabelsImportLabelsValidationRequest.INTERRUPT]: EHttpMethod.DELETE,
    [ELabelsImportLabelsValidationRequest.START]: EHttpMethod.POST,
}

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const LABELS_IMPORT_HANDLE_NEXT = '@@b2b_portal_ui/labelsImport/HANDLE_NEXT';

export const LABELS_IMPORT_SET_FILE_ERROR = '@@b2b_portal_ui/labelsImport/SET_FILE_ERROR';
export const LABELS_IMPORT_SET_FILE_OBJECTS = '@@b2b_portal_ui/labelsImport/SET_FILE_OBJECTS';
export const LABELS_IMPORT_SET_FILE_INFO_ITEMS = '@@b2b_portal_ui/labelsImport/SET_FILE_NAMES';
export const LABELS_IMPORT_SET_FILE_UPLOADED = '@@b2b_portal_ui/labelsImport/SET_FILE_UPLOADED';

export const LABELS_IMPORT_SET_IS_STEP_VALID = '@@b2b_portal_ui/labelsImport/SET_IS_STEP_VALID';

export const LABELS_IMPORT_CLEAR_WIZARD_DATA = '@@b2b_portal_ui/labelsImport/CLEAR_WIZARD_DATA';

export const LABELS_IMPORT_START_EXPORT_ERRORS = '@@b2b_portal_ui/labelsImport/START_EXPORT_ERRORS';

export const LABELS_IMPORT_SET_FILE_META = '@@b2b_portal_ui/labelsImport/SET_FILE_META';
export const LABELS_IMPORT_SET_LABELS_VALIDATION_INFO = '@@b2b_portal_ui/labelsImport/SET_LABELS_VALIDATION_INFO';

export const LABELS_IMPORT_LOAD_LABELS_VALIDATION_FAILURE =
    '@@b2b_portal_ui/labelsImport/SET_LABELS_VALIDATION_FAILURE';
export const LABELS_IMPORT_LOAD_LABELS_VALIDATION_START = '@@b2b_portal_ui/labelsImport/LOAD_LABELS_VALIDATION_START';
export const LABELS_IMPORT_LOAD_LABELS_VALIDATION_STOP = '@@b2b_portal_ui/labelsImport/LOAD_LABELS_VALIDATION_STOP';

export const LABELS_IMPORT_INIT_VALIDATED_LIST = '@@b2b_portal_ui/labelsImport/INIT_VALIDATED_LIST';

export const LABELS_IMPORT_HANDLE_ERROR = '@@b2b_portal_ui/labelsImport/HANDLE_ERROR';

export const LABELS_IMPORT_SET_SAVED_PARAMS = '@@b2b_portal_ui/labelsImport/SET_SAVED_PARAMS';

export const LABELS_IMPORT_SET_TOTAL_ROWS_COUNT = '@@b2b_portal_ui/labelsImport/SET_TOTAL_ROWS_COUNT';
